import { IBackStory } from "@src/components/Backstory";
import image from "../../../../public/images/t3-demo-1.jpg";
import React from "react";
import Image from "next/image";
import { truncate } from "lodash";
import { shimmer, toBase64 } from "@src/utils/shimmer";
import DialogModal from "@src/components/Dialog";
import BackstoryModal from "@src/components/modals/BackstoryModal";
import { getRole } from "@src/utils/general";

const Backstory: React.FC<IBackStory> = ({ eventId, backStoryData }) => {
  return (backStoryData?.getBackStory ?? []).length > 0 ? (
    <section className="bg-[rgba(42,46,50,1)] w-full pb-20 lg:py-24">
      <div className="container mx-auto px-4 max-w-6xl">
        {/* Header */}
        <h3 className="font-andalusia text-[rgba(255,255,255,1)] text-4xl sm:text-5xl capitalize text-center text- mb-10 leading-relaxed">
          Our Love Story
        </h3>

        {/* Two Column Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 sm:gap-12">
          {backStoryData?.getBackStory?.map((story, idx) => (
            <div
              key={idx}
              className="flex flex-col justify-center items-center"
            >
              {/* Title */}
              <h3 className="text-[rgba(255,255,255,1)] text-2xl uppercase font-normal tracking-widest mb-4 px-2 font-brooklyn">
                {story?.title || "Our Story"}
              </h3>

              {/* Image */}
              <div className="w-[20rem] h-[24rem] lg:w-[24rem] lg:h-[28rem] mb-2 rounded-2xl overflow-hidden bg-gray-300 relative">
                <Image
                  placeholder="blur"
                  loading="eager"
                  layout="fill"
                  blurDataURL={`data:image/svg+xml;base64,${toBase64(
                    shimmer(700, 475)
                  )}`}
                  src={story?.image || image}
                  alt={story?.title || "Wedding photo"}
                  className="object-cover"
                  sizes="(max-width: 1000px) 100vw, 500px" // Update sizes accordingly
                />
              </div>

              <p className="text-[rgba(255,255,255,1)] text-base font-normal font-brooklyn leading-relaxed max-w-sm mb-4">
                {truncate(story?.story, {
                  length: 300,
                }) || "Our love story begins here..."}
              </p>
              <p className="text-[rgba(255,255,255,1)] text-sm uppercase font-normal tracking-widest mb-4 px-2 font-brooklyn">
                {getRole(story?.role)}
              </p>

              <div></div>
              <DialogModal
                trigger={
                  <button className="border border-[rgba(255,255,255,1)] text-[rgba(255,255,255,1)] px-6 py-2 text-sm tracking-wider font-brooklyn hover:bg-[rgba(255,255,255,1)] hover:text-[rgba(42,46,50,1)] transition-colors duration-300 rounded">
                    CONTINUE READING
                  </button>
                }
              >
                <BackstoryModal
                  title={story?.title ?? ""}
                  story={story?.story ?? ""}
                  role={getRole(story?.role) ?? ""}
                />
              </DialogModal>
            </div>
          ))}
        </div>
      </div>
    </section>
  ) : (
    <></>
  );
};

export default Backstory;
